import { useGameProviders } from '@/api/game-providers';
import { OrderByProvidersProvidersCardProps } from './props';
import { useInfiniteScroll } from '@starsoft/common/hooks';
import { useClickOutside } from '@starsoft/common/hooks';
import OrderByProvidersProviderCardContent from './Content';
import styles from './styles.module.scss';
import { m } from 'framer-motion';
import { dropIn } from '@starsoft/common/components/SelectInput/variants';

export default function OrderByProvidersProvidersCard({
  handleClose,
}: OrderByProvidersProvidersCardProps) {
  const {
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    gameProviders,
    error,
    refetch,
  } = useGameProviders();
  const { ref } = useInfiniteScroll({
    hasMore: hasNextPage ?? false,
    isLoading: isLoading || isFetchingNextPage,
    loadMore: fetchNextPage,
  });
  useClickOutside({
    open: true,
    onClickOutside: handleClose,
    customRef: ref,
  });

  return (
    <m.div
      className={styles.container}
      ref={ref}
      variants={dropIn}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <OrderByProvidersProviderCardContent
        gameProviders={gameProviders ?? []}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        refetch={refetch}
        error={error}
      />
    </m.div>
  );
}
